<template>
  <div class="gongde-box-payment-container"></div>
</template>

<script>
import qs from 'qs';
export default {
  name: 'GongdePayment',
  data() {
    return {
      // 0 :'未支付',  1 '已支付,待发货', 2: '已取消', 3 : '已退款',  4 : '部分退款',  5 : '已发货，待收货', 6: '已完成',
      statusMap: {
        0: '正在跳转支付',
        1: '订单已支付，待发货',
        2: '订单已取消',
        3: '订单已退款',
        4: '订单部分退款',
        5: '订单已发货，待收货',
        6: '订单已完成',
      },
    };
  },
  mounted() {
    this.onOrderTips();
  },
  methods: {
    async onOrderTips() {
      this.$toast.loading({ duration: 0 });
      try {
        const queryObject = this.parseQueryParams();

        const {
          fu_de,
          default: defaultUrl,
          order_center_id,
          ali_pay_channel,
          wechatv3_official,
          wechat_office_pay_channel,
        } = queryObject;
        if (fu_de) {
          this.$toast({ message: `功德值+${fu_de}`, duration: 0 });
          return;
        }
        if (defaultUrl && order_center_id && ali_pay_channel && wechatv3_official && wechat_office_pay_channel) {
          if (this.$tools.isWeChat()) {
            location.href = `https://${wechatv3_official}/pay?order_id=${order_center_id}&channel_id=${wechat_office_pay_channel}`;
          } else {
            location.href = `https://${defaultUrl}/pay?order_id=${order_center_id}&channel_id=${ali_pay_channel}`;
          }
        } else {
          this.$toast({ message: '未查询到支付信息', duration: 0 });
        }
      } catch (error) {
        console.log(error);
        this.$toast({ message: '未查询到支付信息', duration: 0 });
      }
    },

    parseQueryParams(search = location.search, convertNumbers = true) {
      // 移除开头的问号
      let searchString = search.charAt(0) === '?' ? search.substring(1) : search;

      // 处理空字符串情况
      if (!searchString) {
        return {};
      }

      // 检查是否整个查询字符串被编码
      const isFullyEncoded = searchString.includes('%3D') && searchString.includes('%26');

      let queryObject = {};

      if (isFullyEncoded) {
        // 对整个查询字符串解码
        const decodedString = decodeURIComponent(searchString);

        // 检查解码后的字符串是否为标准查询字符串格式
        if (decodedString.includes('=') && decodedString.includes('&')) {
          const pairs = decodedString.split('&');
          pairs.forEach(pair => {
            if (pair.includes('=')) {
              const [key, value] = pair.split('=');
              queryObject[key] = convertNumbers && /^\d+$/.test(value) ? Number(value) : value;
            }
          });
        } else {
          // 如果解码后仍不是标准格式，则作为单一参数处理
          queryObject = { query: decodedString };
        }
      } else {
        // 标准格式的查询参数
        const searchParams = new URLSearchParams(searchString);
        searchParams.forEach((value, key) => {
          queryObject[key] = convertNumbers && /^\d+$/.test(value) ? Number(value) : value;
        });
      }

      return queryObject;
    },
  },
};
</script>

<style lang="less" scoped>
.gongde-box-payment-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fcf5ec;
  background-image: url('https://fe-img.tengzhihh.com/image/54c89981c5251e5cd8996007d316e476-800x1280.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
